
import Home from "./components/home/Home";
import Navbar from "./components/Navbar";
import { BrowserRouter, Route,  Routes } from "react-router-dom";
import Service from "./components/service/Service";
import Footer from "./components/Footer";
import ServiceDetail from "./components/service/ServiceDetail";
import HomeContact from "./components/home/HomeContact";
import ServiceCommercial from "./components/service/ServiceCommercial";
import ServiceDecor from "./components/service/ServiceDecor";
import ServiceFurniture from "./components/service/ServiceFurniture";
import ServiceInterior from "./components/service/ServiceInterrior";
import Aboutus from "./components/aboutus/Aboutus";

function App() {
  return (
    <>
    
    <BrowserRouter>
    <Navbar/>
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/services" element={<Service />} />
        <Route path="/landscape" element={<ServiceDetail />} />
        <Route path="/commercial" element={<ServiceCommercial />} />
        <Route path="/decor" element={<ServiceDecor />} />
        <Route path="/hospitality" element={<ServiceFurniture />} />
        <Route path="/interior" element={<ServiceInterior />} />
        <Route path="/contact-us" element={<HomeContact />} />

      </Routes>
    <Footer/>
    
    </BrowserRouter>
    </>

  );
}

export default App;
